import { GroupConfig } from "./environment.interface";
import { GROUP_CONFIG as prod } from "./group_config.prod";
const groupIds = ['0006sxo2xghyM82souGewauAW']; // prodと共通のgroupId
//
export const GROUP_CONFIG:GroupConfig[] = [
    ...prod.filter( $_ => groupIds.includes($_.groupId) ),
    {
        groupId : '0005Juaoofoxq0e4yUCgayw0c',
        // isSaga: true,
        // backUrl: '/',
        tags: [
            {rel:'apple-touch-icon', sizes: '180x180',href:"/assets/img/0005Juaoofoxq0e4yUCgayw0c/favicon.ico"},
            // {rel:'icon',href:"/assets/img/0002hkFNLFFGI4mUYYumGyCco/favicon.ico"},
            // {rel:'apple-touch-icon', sizes: '180x180',href:"/assets/img/0002hkFNLFFGI4mUYYumGyCco/favicon.ico"},
        ]
    },
];
